// GetCustomer returns the customer data for the given customer session. A valid CO session is required to get this data.
//
// Deprecated: use [GetCustomerData], which returns the BI tracking data alongside the personal
// data and degrades gracefully once the CO session has expired.
export const CustomerService_GetCustomerLazy = () =>
  import("./service.grpc").then((m) => m.CustomerService_GetCustomer);
CustomerService_GetCustomerLazy.method =
  "aysa_api.services.customer.CustomerService/GetCustomer" as const;

// GetCustomerData returns the customer's personal data together with their BI tracking data.
export const CustomerService_GetCustomerDataLazy = () =>
  import("./service.grpc").then((m) => m.CustomerService_GetCustomerData);
CustomerService_GetCustomerDataLazy.method =
  "aysa_api.services.customer.CustomerService/GetCustomerData" as const;
